export default __webpack_public_path__ + "static/media/DanskeNarrowSemibold.617d34ec.woff";